export type TDevice = 'mobile' | 'tablet' | 'desktop';
import { identifyDeviceType, TDevice as TDeviceUtils } from '@cian/utils';

export const getDeviceType = (userAgent?: string): TDevice => {
  const deviceType: TDeviceUtils = identifyDeviceType(userAgent);

  return deviceType === 'phone' ? 'mobile' : deviceType;
};
